import { activityActionLabel, describeActivity, localeDate } from '../i18n/helpers';

export const ACTION_OPTIONS = [
  'USER_LOGIN', 'USER_LOGOUT', 'PROFILE_UPDATED', 'PASSWORD_CHANGED',
  'TENANT_APPROVED', 'TENANT_REJECTED', 'TENANT_SUSPENDED', 'TENANT_CANCELLED', 'TENANT_REACTIVATED',
  'TENANT_IMPERSONATED', 'IMPERSONATION_STARTED', 'USER_DEACTIVATED', 'USER_REACTIVATED',
  'APPOINTMENT_CREATED', 'APPOINTMENT_APPROVED', 'APPOINTMENT_ASSIGNED', 'APPOINTMENT_REASSIGNED',
  'APPOINTMENT_ASSIGNMENT_ACCEPTED', 'APPOINTMENT_ASSIGNMENT_REJECTED', 'APPOINTMENT_ASSIGNMENT_CANCELLED',
  'APPOINTMENT_COMPLETED', 'APPOINTMENT_CANCELLED', 'APPOINTMENT_PRICE_ADJUSTED',
  'ORDER_PLACED', 'ORDER_CONFIRMED', 'ORDER_SHIPPED', 'ORDER_DELIVERED', 'ORDER_REJECTED', 'ORDER_PRICE_ADJUSTED',
  'PRODUCT_CREATED', 'PRODUCT_UPDATED', 'PRODUCT_PUBLISHED', 'PRODUCT_DELETED',
  'SERVICE_CREATED', 'SERVICE_UPDATED',
  'STAFF_INVITED', 'STAFF_DEACTIVATED', 'STAFF_REACTIVATED', 'STAFF_PERMISSIONS_UPDATED', 'STAFF_SPECIALTIES_UPDATED',
  'REPORT_EXPORTED', 'PAYMENT_SLIP_UPLOADED', 'PAYMENT_SLIP_VERIFIED',
  'REVIEW_SUBMITTED', 'REVIEW_UPDATED', 'REVIEW_DELETED', 'REVIEW_REPLIED', 'REVIEW_PUBLISHED', 'REVIEW_UNPUBLISHED',
].sort();

export { describeActivity, activityActionLabel as activityLabel };

export const activityIcon = (action) => {
  if (action?.includes('APPOINTMENT')) return '📅';
  if (action?.includes('ORDER')) return '📦';
  if (action?.includes('PRODUCT')) return '🛍️';
  if (action?.includes('SERVICE')) return '✂️';
  if (action?.includes('STAFF')) return '👤';
  if (action?.includes('PAYMENT')) return '💳';
  if (action?.includes('REPORT')) return '📥';
  if (action?.includes('TENANT')) return '🏢';
  if (action?.includes('USER') || action?.includes('PROFILE') || action?.includes('PASSWORD')) return '🔐';
  return '•';
};

export const groupLogsByDate = (logs) => {
  const groups = {};
  (logs || []).forEach((log) => {
    const key = localeDate(log.createdAt, { day: 'numeric', month: 'long', year: 'numeric' });
    if (!groups[key]) groups[key] = [];
    groups[key].push(log);
  });
  return groups;
};
